import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import AuthInterceptor from './components/AuthInterceptor';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <AuthInterceptor>
          <SocketProvider>
            <App />
          </SocketProvider>
        </AuthInterceptor>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
